import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

export const LanguageModal = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    // Check if user has already made a selection this session
    const hasSelected = sessionStorage.getItem('languageSelected');
    if (!hasSelected) {
      setIsOpen(true);
    }
  }, []);

  const handleSelect = useCallback((lang) => {
    i18n.changeLanguage(lang);
    sessionStorage.setItem('languageSelected', 'true');
    setIsOpen(false);
  }, [i18n]);

  useEffect(() => {
    if (!isOpen) return;

    if (timeLeft === 0) {
      handleSelect('en');
      return;
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [isOpen, timeLeft, handleSelect]);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      // If the dialog is closed without making a selection (e.g. clicking outside), default to English
      if (!open) {
        handleSelect('en');
      }
    }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center text-2xl font-bold font-['Outfit'] mb-2">
            Choose Your Language
          </DialogTitle>
          <DialogDescription className="text-center text-lg font-medium text-emerald-700 font-['Outfit'] mb-4">
            మీ భాషను ఎంచుకోండి
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <div className="text-center text-sm font-medium text-slate-500 mb-2">
            Defaulting to English in <span className="font-bold text-emerald-600">{timeLeft}s</span>
          </div>
          <Button 
            onClick={() => handleSelect('en')}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-6 text-lg rounded-xl flex items-center justify-between px-6"
          >
            <span>English</span>
            {timeLeft <= 10 && <span className="text-emerald-200 text-sm">({timeLeft}s)</span>}
          </Button>
          <Button 
            onClick={() => handleSelect('te')}
            className="w-full bg-amber-500 hover:bg-amber-600 text-white py-6 text-lg rounded-xl"
          >
            తెలుగు (Telugu)
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
